import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../../Timps/Switch/style";
import { ReportGroupingUtils } from "../../../utils/reportGroupingUtils";
import React from "react";
import ReportTitleSection from "../../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { path_36MonthsReportSchema, RemarksTable } from "./schema";

export const Path_36daysInspectionReport = (props) => {
  const { reportData } = props;

  let injectedUserData = ReportGroupingUtils.injectUserInfoInReportData(reportData, props.userList);
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(injectedUserData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, ["path_36MonthsForm"]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => {
    return <ViewReport key={i} data={report} {...props} />;
  });
};

const ViewReport = (props) => {
  const { data, title, userList } = props;
  const { decodedData, email } = data;

  let inspector = userList.find((u) => u.email === email);

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      {decodedData.map((singleReport, index) => {
        return (
          <div key={index}>
            <ReportTitleSection title={title} fontSizeOverride={"35px"} />

            <ReportFraInfoSectionContainer {...props} data={{ ...data, employeeNumber: inspector && inspector.employeeNumber }} />

            <span className="spacer"></span>

            <strong>
              Following inspection tests were performed (as applicable) by inspectors listed below and left in good condition for service.
              Any items found to be defective or replaced are listed in the <span style={{ fontStyle: "italic" }}>REMARKS</span> section.
            </strong>

            <span className="spacer"></span>

            <table className="table-bordered">
              {path_36MonthsReportSchema.map((section, key) => (
                <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={key} />
              ))}
            </table>

            <table className="table-bordered">
              <ReportTableSectionRenderer section={RemarksTable} rowsData={singleReport.summary.remarksTable || []} />
            </table>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/PATH/36MonthsReport/index.jsx